import React from 'react';
import styled, { keyframes } from 'styled-components';

import Loading from '@williamhill/rosi-ui-shared/src/assets/icons/loading';

export default function LoadingSpinner({
  width,
  color,
  className = 'qa-loading-spinner',
  duration = '2s'
}: {
  width?: string;
  color?: string;
  className?: string;
  duration?: string;
}) {
  return (
    <LoadingSpinnerWrapper duration={duration} className={className} data-testid="qa-loading-spinner">
      <Loading fill={color} width={width} style={{ display: 'block' }} />
    </LoadingSpinnerWrapper>
  );
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoadingSpinnerWrapper = styled.div<{ duration: string }>`
  animation: ${rotate} linear infinite;
  ${({ duration }) => `animation-duration: ${duration}`};
  display: inline-block;
`;
